import { get } from '../../../../infra/rest';
import { urlCreator } from '../../../../shared/utils/url-helpers';
import { GetAllCustomFieldsLeadStatusProps, ChatStatuses } from '../typings';
import { CustomFieldCondition } from '../components/chat-list-section/custom-field-filter/typings';
import { serializeConditionsForWire } from '../components/chat-list-section/custom-field-filter/utils';

async function getAllCustomFieldsLeadStatus(
  status: ChatStatuses,
  searchTerm: string,
  assignedUserId: string,
  wabas: string[],
  slaStatus: string,
  tags: string[],
  tagIds: string[],
  signal: AbortSignal,
  customFieldConditions?: CustomFieldCondition[]
): Promise<GetAllCustomFieldsLeadStatusProps> {
  const queryParams = new URLSearchParams();
  if (searchTerm) {
    queryParams.append('searchTerm', searchTerm);
  }
  if (slaStatus) {
    queryParams.append('slaStatus', slaStatus);
  }

  if (status) {
    queryParams.append('status', status);
  }
  if (assignedUserId) {
    queryParams.append('assignedUserId', assignedUserId);
  }

  if (!!wabas && wabas?.length > 0) {
    wabas.forEach((waba) => {
      if (typeof waba === 'string' && waba.length > 0) {
        queryParams.append('waba', waba);
      }
    });
  }
  if (!!tags && tags?.length > 0) {
    tags.forEach((tag) => {
      if (typeof tag === 'string' && tag.length > 0) {
        queryParams.append('tags_v2', tag);
      }
    });
  }

  if (tagIds?.length > 0) {
    tagIds.forEach((tagId) => {
      if (typeof tagId === 'string' && tagId.length > 0) {
        queryParams.append('tag_ids', tagId);
      }
    });
  }

  const completeConditions = serializeConditionsForWire(customFieldConditions ?? []);
  if (completeConditions.length > 0) {
    queryParams.append('customFields_v3', JSON.stringify(completeConditions));
  }

  const url = urlCreator({
    baseUrl: `/v1/custom-fields/lead-status${queryParams.toString().length > 0 ? `?${queryParams.toString()}` : ''}`,
  });
  return get<GetAllCustomFieldsLeadStatusProps>(url, undefined, true, false, false, false, false, signal);
}
export { getAllCustomFieldsLeadStatus };
